import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { testimonials, platformFeatures } from '@/mocks/testimonials';

export default function About() {
  return (
    <>
      <Navbar />

      <main>
        {/* Brand Story */}
        <section className="pt-28 pb-16 md:pt-32 md:pb-20 bg-accent-50">
          <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="lg:w-[200px] shrink-0">
                <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-foreground-500 whitespace-nowrap">
                  <span className="w-3 h-[1px] bg-foreground-400"></span>
                  品牌故事
                </span>
              </div>
              <div className="flex-1">
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 tracking-tight">
                  关于五一黑料网
                </h1>
                <div className="mt-6 space-y-4">
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    五一黑料网创立于2024年5月1日，是国内领先的娱乐八卦与爆料内容聚合平台。
                    我们秉持"还原真相、理性吃瓜"的核心理念，致力于为广大吃瓜群众提供最及时、
                    最全面、最可靠的黑料资讯服务。
                  </p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    在这个信息爆炸的时代，真假难辨的八卦消息充斥着互联网的每一个角落。
                    五一黑料网的诞生，正是为了改变这一现状。我们建立了一套严格的多重信息核实机制，
                    每一条爆料在发布之前，都必须经过至少三个独立信源的交叉验证。
                  </p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    我们的编辑团队由资深娱乐记者、前MCN机构运营人员和数据分析师组成，
                    遍布全国主要城市的线人网络确保了我们能够第一时间获取到最劲爆的黑料信息。
                    从网红翻车到明星塌房，从综艺内幕到影视揭秘，我们覆盖了娱乐圈的每一个角落。
                  </p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    我们深知，黑料的本质不是恶意中伤，而是还原被刻意隐藏的事实。
                    五一黑料网始终坚守"不造谣、不传谣、不人身攻击"的三不原则，
                    在追求真相的同时，也尊重每一个当事人的基本权利。
                  </p>
                </div>
                <div className="mt-8 flex items-center gap-4">
                  <span className="text-[11px] text-foreground-400">
                    <span className="w-1.5 h-1.5 rounded-full bg-foreground-300 inline-block mr-1.5"></span>
                    创始团队
                  </span>
                  <div className="flex -space-x-2">
                    <div className="w-9 h-9 rounded-full bg-primary-200 border-2 border-accent-50 flex items-center justify-center">
                      <i className="ri-user-line text-xs text-primary-600"></i>
                    </div>
                    <div className="w-9 h-9 rounded-full bg-secondary-200 border-2 border-accent-50 flex items-center justify-center">
                      <i className="ri-user-line text-xs text-secondary-600"></i>
                    </div>
                    <div className="w-9 h-9 rounded-full bg-accent-200 border-2 border-accent-50 flex items-center justify-center">
                      <i className="ri-user-line text-xs text-accent-600"></i>
                    </div>
                    <div className="w-9 h-9 rounded-full bg-primary-200 border-2 border-accent-50 flex items-center justify-center">
                      <i className="ri-user-line text-xs text-primary-600"></i>
                    </div>
                  </div>
                  <span className="text-[11px] text-foreground-500">五一黑料网创始团队</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-4 bg-background-50">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        {/* Platform Features */}
        <section id="features" className="py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 text-xs font-semibold rounded-full border border-background-300 text-foreground-600 whitespace-nowrap">
                平台特色
              </span>
              <h2 className="mt-4 text-2xl md:text-3xl font-heading font-bold text-foreground-900 tracking-tight">
                为什么选择五一黑料网
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
                我们不只是爆料的搬运工，更是真相的守护者
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {platformFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60 hover:bg-primary-500 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center group-hover:bg-white/20 transition-colors duration-300">
                    <i className={`${feature.icon} text-lg text-foreground-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                  </div>
                  <h3 className="mt-4 text-sm font-semibold text-foreground-800 group-hover:text-background-50 transition-colors duration-300 whitespace-nowrap">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 group-hover:text-background-200/80 transition-colors duration-300 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="py-16 md:py-20 bg-background-100">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 text-xs font-semibold rounded-full border border-background-300 text-foreground-600 whitespace-nowrap">
                用户口碑
              </span>
              <h2 className="mt-4 text-2xl md:text-3xl font-heading font-bold text-foreground-900 tracking-tight">
                吃瓜群众怎么说
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((t, index) => (
                <div
                  key={index}
                  className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/60"
                >
                  <div className="flex items-center gap-1 mb-5 text-accent-500">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="text-sm text-foreground-700 leading-relaxed italic">
                    &ldquo;{t.quote}&rdquo;
                  </blockquote>
                  <div className="mt-5 pt-5 border-t border-background-200/70">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-800">{t.author}</span>
                      {t.verified && (
                        <span className="flex items-center gap-0.5 text-[10px] text-accent-600">
                          <i className="ri-verified-badge-line text-xs"></i>
                          已认证
                        </span>
                      )}
                    </div>
                    <span className="text-[11px] text-foreground-400 mt-0.5 block">{t.platform}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="flex-1">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 tracking-tight">
                  联系我们
                </h2>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-md">
                  如果您有爆料线索、商务合作需求或内容侵权投诉，欢迎通过以下方式与我们取得联系。
                  我们会在24小时内回复您的来信。
                </p>

                <div className="mt-8 flex flex-col gap-5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">电子邮箱</p>
                      <p className="text-sm font-medium text-foreground-700">contact@wuyiheiliao.com</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                      <i className="ri-smartphone-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">爆料热线</p>
                      <p className="text-sm font-medium text-foreground-700">400-888-5151</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center shrink-0">
                      <i className="ri-map-pin-line text-secondary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">办公地址</p>
                      <p className="text-sm font-medium text-foreground-700">北京市朝阳区建国路88号SOHO现代城A座15层</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div className="rounded-2xl overflow-hidden aspect-[16/10]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20warm%20cream%20and%20beige%20interior%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20clean%20desk%20with%20laptop%2C%20editorial%20photography%2C%20calm%20and%20professional%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition&width=900&height=560&seq=about-contact&orientation=landscape"
                    alt="五一黑料网办公室"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="w-full flex flex-col lg:flex-row">
          <div className="lg:w-1/2 relative min-h-[360px] md:min-h-[440px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cream%20and%20beige%20abstract%20gradient%20background%20with%20soft%20textured%20patterns%2C%20elegant%20minimalist%20atmosphere%2C%20subtle%20geometric%20lines%2C%20warm%20natural%20lighting%2C%20editorial%20style%2C%20calm%20and%20sophisticated%20composition&width=900&height=700&seq=about-cta-left&orientation=landscape"
              alt="五一黑料网"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-100/30 to-transparent"></div>
            <div className="absolute top-8 left-8">
              <span className="text-[11px] font-medium text-foreground-700 uppercase tracking-wider whitespace-nowrap">
                加入我们
              </span>
            </div>
            <div className="absolute bottom-10 left-8 right-8">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight tracking-tight">
                你有猛料
                <br />
                我们有平台
                <br />
                一起还原真相
              </h2>
            </div>
          </div>

          <div className="lg:w-1/2 bg-background-50 flex items-center justify-center py-16 px-8 md:px-16">
            <div className="text-center max-w-md">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 leading-tight tracking-tight">
                欢迎提供
                <br />
                爆料线索
              </h2>
              <p className="mt-5 text-sm text-foreground-600 leading-relaxed">
                如果你掌握了一手黑料信息，欢迎通过上方联系方式与我们取得联系。
                所有爆料者信息均严格保密，你的每一次发声，都可能成为还原真相的关键一步。
              </p>
              <Link
                to="/category/wanghong-heliao"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
              >
                浏览最新爆料
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于五一黑料网',
            description: '五一黑料网创立于2024年5月1日，是国内领先的娱乐八卦与爆料内容聚合平台。我们秉持"还原真相、理性吃瓜"的核心理念。',
            url: 'https://www.wuyiheiliao.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '五一黑料网',
              url: 'https://www.wuyiheiliao.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.wuyiheiliao.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '五一黑料网的爆料内容是否真实可靠？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的。我们建立了一套严格的多重信息核实机制，每一条爆料在发布之前都必须经过至少三个独立信源的交叉验证，确保内容的真实性和可靠性。',
                },
              },
              {
                '@type': 'Question',
                name: '如何向五一黑料网提供爆料线索？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过发送邮件至 contact@wuyiheiliao.com 或拨打爆料热线 400-888-5151 与我们取得联系。所有爆料者信息均全程加密保护。',
                },
              },
              {
                '@type': 'Question',
                name: '五一黑料网的内容是否免费？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，五一黑料网的所有内容均免费向公众开放，无需下载任何APP或注册账号即可浏览全部爆料内容。',
                },
              },
              {
                '@type': 'Question',
                name: '如果发现内容不实，如何申请更正？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '如您发现本站内容存在不实之处，欢迎通过邮箱 contact@wuyiheiliao.com 与我们联系，我们将在核实后第一时间进行更正或删除。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}